var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isReady)?_c('div',{attrs:{"id":"app"}},[(_vm.$root.$user)?_c('div',[_c('router-view')],1):_c('div',[_c('login-modal',{ref:"refLoginModal"})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }